<template>
  <!-- 为 ECharts 准备一个定义了宽高的 DOM -->
  <div ref="chart" style="width: 100%;"></div>
</template>

<script>
// import * as echarts from 'echarts/core'
import * as echarts from "echarts";
export default {
  name: "lineChart",
  data() {
    return {
      successlist: {
        typadata: ["销售水量", "主营业务"], // 标题
        xAxisdata: [
          "当年完成水量",
          "去年同期水量",
          "滚动目标值水量",
          "全年目标值水量",
          "当年完成金额",
          "去年同期金额",
          "滚动目标金额",
          "全年目标值"
        ], //x轴
        xiaoshoudata: [4.2, 3.8, 4.8, 3.5, 2.9, 2.8, 3, 5],
        zhuyingdata: [4.2, 3.8, 4.8, 3.5, 2.9, 2.8, 3, 5]
      }
    };
  },
  mounted() {},
  methods: {
    initChart(repurchaseData) {
      const myChart = echarts.init(this.$refs.chart);
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: "用户复购趋势图",
          textStyle: {
            align: "center",
            fontSize: 20
          },
          top: "3%",
          left: "center"
        },
        // backgroundColor: "#0f375f",
        grid: {
          top: "25%",
          bottom: "10%" //也可设置left和right设置距离来控制图表的大小
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true
            }
          }
        },
        legend: {
          data: repurchaseData.typadata,
          top: "15%"
        },
        xAxis: {
          data: repurchaseData.month,
          axisLine: {
            show: true //隐藏X轴轴线
            // lineStyle: {
            //   color: "#01FCE3"
            // }
          },
          axisTick: {
            show: true //隐藏X轴刻度
          },
          axisLabel: {
            show: true
            // textStyle: {
            //   color: "#ebf8ac" //X轴文字颜色
            // }
          }
        },
        yAxis: [
          {
            type: "value",
            name: "数量",
            // nameTextStyle: {
            //   color: "#ebf8ac"
            // },
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true
              // lineStyle: {
              //   color: "#FFFFFF"
              // }
            },
            axisLabel: {
              show: true
              // textStyle: {
              //   color: "#ebf8ac"
              // }
            }
          },
          {
            type: "value",
            name: "同比",
            // nameTextStyle: {
            //   color: "#ebf8ac"
            // },
            position: "right",
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              formatter: "{value} %" //右侧Y轴文字显示
              // textStyle: {
              //   color: "#ebf8ac"
              // }
            }
          },
          {
            type: "value",
            gridIndex: 0,
            min: 50,
            max: 100,
            splitNumber: 8,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ["rgba(250,250,250,0.0)", "rgba(250,250,250,0.05)"]
              }
            }
          }
        ],
        series: [
          {
            name: repurchaseData.typadata[0],
            type: "line",
            yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
            smooth: true, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 10, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "#058cff"
            },
            lineStyle: {
              color: "#058cff"
            },
            areaStyle: {
              color: "rgba(5,140,255, 0.2)"
            },
            data: repurchaseData.fugou
          },
          {
            name: repurchaseData.typadata[1],
            type: "bar",
            barWidth: 15,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00FFE3"
                  },
                  {
                    offset: 1,
                    color: "#4693EC"
                  }
                ])
              }
            },
            data: repurchaseData.chengjiao
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/statistics/user/part/echarttwo.vue